/**
 * Controller: SelectAddressModal
 */
angular.module('acme.view.application.partners.create.selectAddressModal.controllers', [
  'acme.common.service.api',
  'acme.common.service.validate'
])
.controller('SelectAddressModalController', [ '$scope', '$state', '$uibModalInstance', 'ApiService', 'ValidateService', 'address', 'contactId', 'organizationId', function($scope, $state, $uibModalInstance, ApiService, ValidateService, address, contactId, organizationId) {

    $scope.selectAddressModal = {

      errors: [],

      isSubmitted: false,

      model: {},
      organizationId: '',
      createAddress: false,
      address: false,
      viewId: $state.current.name,
      loadPreferences: $state.current.data.enablePreferences,

      init: function() {

        if (organizationId) {
          this.organizationId = organizationId;
        }

        if (address) {
          this.model = address;
        }

        $scope.$on('AddressCreate::Close', this.onAddressCreateClose);
        $scope.$on('AddressCreate::Complete', this.onAddressCreateComplete);
        $scope.$on('AddressList::Create', this.onAddressListCreate);
        $scope.$on('AddressList::Select', this.onAddressListSelect);
        $scope.$on('AddressList::Edit', this.onAddressListEdit);
      },

      getAddress: function() {
        ApiService.organizations.contacts.detail({
          organizationId: organizationId,
          contactId: contactId
        }).then(this.success.getAddress, this.error.getAddress);
      },

      isValid: function(field) {
        var r = true;

        if(this.isSubmitted) {
          r = ValidateService.validate([
            {
              len: {
                value: this.model[field]
              }
            }
          ]);
        }
        return r;
      },

      isValidEmail: function(email) {
        var r = true;

        if(this.isSubmitted) {
          r = ValidateService.validate([{email: email}]);
        }
        return r;
      },

      isValidPhone: function(phone) {
        var r = true;
        if(this.isSubmitted) {
          r = ValidateService.validate([{phone: phone}]);
        }
        return r;
      },

      done: function() {
        var self = $scope.selectAddressModal;

        self.isSubmitted = true;
        $scope.$broadcast('AddressCreate::Check');
        self.prepareAddress();
        if (ValidateService.validate([
            { len: { value: self.model.firstName } },
            { len: { value: self.model.lastName } },
            { email: self.model.email },
            { phone: self.model.phoneNumber },
            { len: { value: self.model.country } },
            { len: { value: self.model.streetAddress1 } },
            { len: { value: self.model.city } },
            { len: { value: self.model.state } },
            { len: { value: self.model.zipCode } }
          ])) {
          $uibModalInstance.close(this.model, this.address);
        }else {
          self.errors = [ {message: 'Please correct the errors below.'} ];
        }

        if (this.model) {
          $uibModalInstance.close(this.model);
        }else {
          self.errors = [ {message: 'You must select an address.'} ];
        }
      },

      cancel: function() {
        $uibModalInstance.dismiss('cancel');
      },

      success: {
        getAddress: function(response) {}
      },

      error: {
        getAddress: function(response) {}
      },

      prepareAddress: function() {

        // Only replace if this is not a user model
        // Confusing but basically we either get an address with a user attached or we don't
        // This overloads the ID field so we need to differentiate here
        if (!this.model.hasOwnProperty('email') &&
            !this.model.hasOwnProperty('phoneNumber') &&
            !this.model.hasOwnProperty('companyUrl')) {
          this.model.id = this.address.id;
        }
        this.model.addressId = this.address.addressId;
        this.model.streetAddress1 = this.address.streetAddress1;
        this.model.streetAddress2 = this.address.streetAddress2;
        this.model.city = this.address.city;
        this.model.state = this.address.state;
        this.model.zipCode = this.address.zipCode;
        this.model.country = this.address.country;
        this.model.isPrimary = this.address.isPrimary;
      },

      onAddressCreateComplete: function(e, data) {
        var self = $scope.selectAddressModal;

        self.errors = [];

        if (data.select) {
          self.createAddress = false;
          self.address = data.address;
          self.prepareAddress();
        }

        $scope.$broadcast('AddressList::Refresh', { address: self.address });
      },

      onAddressCreateClose: function(e, data) {
        $scope.selectAddressModal.createAddress = false;
      },

      onAddressListEdit: function(e, data) {
        var self = $scope.selectAddressModal;

        self.address = data.address;
        self.createAddress = true;
      },

      onAddressListCreate: function(e, data) {
        var self = $scope.selectAddressModal;

        self.address = {
          country: '',
          type: 'secondary'
        };

        self.createAddress = true;
      },

      onAddressListSelect: function(e, data) {
        var self = $scope.selectAddressModal;

        if (data.selected) {
          self.address = data.address;
          // Create addressId field from address object
          self.address.addressId = self.address.id;
        }

      }

    };


    $scope.selectAddressModal.init();

}]);